$(function(){
    if (!window.salba) Object.create(window.salba = {});

    const $sa = {
        discountCode: "",
        discountPercentage: 0,
        discountAmount: 0,
        originalPric: 0,
        priceAfterDiscount: 0,
        auth_token: "",
        init:function(options){
            
            return this;
        },

        getAuthToken: function(callback){
            console.log("Fetching Auth Token");
            fetch("/payments/config", {"method": "GET"})
            .then(function(response) { return response.json() })
            .then(function(data) {
                let auth_token = btoa(data.paymentInstruments.accessToken)
                callback(auth_token);
            });
        },

        applyDiscount:function(code) {
            let ths = this;
            this.getAuthToken(function(authorization_token){
                // console.clear();
                console.log("Getting Token and Applying");
                // console.log("Authorization Token", authorization_token); 
                console.log("Discount Code", code);   
                
                fetch('/cart.js', {}).then(function(res){return res.json();})
                .then(function(data){
                    // console.log("Cart Data", data);
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            discount: code
                        })
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        fetch('/cart.js', {}).then(function(res){return res.json();})
                        .then(function(cartData){
                            // console.log("Cart Data After Discount", cartData);
                            ths.discountCode = code;
                            ths.discountPercentage = cartData.cart_level_discount_applications.length > 0 ? cartData.cart_level_discount_applications[0].value : 0;
                            ths.discountAmount = cartData.total_discount;
                            ths.originalPrice = cartData.original_total_price;
                            ths.priceAfterDiscount = cartData.total_price;
                            
                            // Update UI or perform any other actions needed
                            console.log("Discount Applied Successfully");
                        });
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });

                });
            });
        },

        resetDiscount:function(){
            console.log("Resetting Discount");
            fetch("/checkout?discount=CLEAR")
            .then(function(response) { return response.json() })
            .then(function(data) {
                console.log("Discount Reset", data);
            });
            // $.removeCookie('discount_code', { path: '/' });
            $.cookie("discount_code", "", { expires: -1 });
        }

    }

    if(window) $.extend(salba, $sa);

    var customerDiscount = salba.init();
    customerDiscount.applyDiscount(salba_discount_tag_used);
});